/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import { basePath, isAnalyticsEnabled } from '../constants/commonConstants';
import { makeRequest, sendAnalyticsEvent } from '../helpers';
import type {
  AppliedDocument,
  AppliedDocumentGroup,
  AppliedGroupedDocumentsRequest,
  DocumentSummaryRequest,
  RenewalQuoteResponseModel
} from '../types/Home';

export const getRenewalQuote = async (
  // eslint-disable-next-line flowtype/no-weak-types
  homeRenewalData: any,
  // eslint-disable-next-line no-unused-vars, flowtype/no-weak-types
  match: any,
  // eslint-disable-next-line no-empty-pattern, flowtype/no-weak-types
  {  }: any
): Promise<RenewalQuoteResponseModel[] | { error?: boolean }> => {
  const quoteRequest = makeRequest({
    method: 'POST',
    url: `${basePath}/home/applied_home_renewal/`,
    payload: homeRenewalData
  });

  return await quoteRequest;
};

export const postHomeQuote = async (
  // eslint-disable-next-line flowtype/no-weak-types
  homeQuoteData: any,
  // eslint-disable-next-line flowtype/no-weak-types
  props: any = {}
) => {
  const quoteRequest = await makeRequest({
    method: 'POST',
    url: `${basePath}/home/applied_home_quotes`,
    payload: homeQuoteData,
    history: props.history
  });

  if (isAnalyticsEnabled) {
    sendAnalyticsEvent(quoteRequest, 'insuranceEvent', 'Home');
  }
  return quoteRequest;
};

export const getAppliedAddress = async (
  // eslint-disable-next-line flowtype/no-weak-types
  payloadObj: any,
  manual: boolean = false
) => {
  let manualURL = manual ? 'manual_address' : 'address';
  const quoteRequest = makeRequest({
    method: 'POST',
    url: `${basePath}/home/applied_home_quotes/${manualURL}`,
    payload: {
      ...payloadObj
    }
  });

  return await quoteRequest;
};

export const getTownAndCounty = async () => {
  return makeRequest({
    method: 'GET',
    url: `${basePath}/home/applied_home_quotes/address/code_list`
  });
};

export const getRenewalDocumentLinks = async (
  payload: DocumentSummaryRequest
): Promise<AppliedDocument[]> =>
  makeRequest({
    url: `${basePath}/home/applied_home_documents/renewal/summary`,
    method: 'POST',
    payload,
    onError: () => []
  });

export const getHomeDocumentLinks = async (
  payload: AppliedGroupedDocumentsRequest
): Promise<AppliedDocumentGroup[]> =>
  makeRequest({
    url: `${basePath}/home/applied_home_documents/summary`,
    method: 'POST',
    payload,
    onError: () => []
  });
